import ReportUpdate from './reportUpdate.js';
export default ReportUpdate;
